import ModalComponent from 'components/Common/Modal';
import usePushNotifications from 'components/Settings/EmailAlerts/usePushNotifications';
import { useState } from 'react';
import LocalStorage from 'utils/LocalStorage';

const PushNotificationsConfirmation = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { pushNotificationModalState } = props ?? {};
  const { showPushNotificationsModal, setShowPushNotificationsModal } = pushNotificationModalState ?? {};
  const { subscribePushNotifications } = usePushNotifications();

  const requestPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      setIsLoading(true);
      await subscribePushNotifications();
      setIsLoading(false);
      setShowPushNotificationsModal(false);
    }
  };

  return (
    <ModalComponent isOpen={showPushNotificationsModal} setIsOpen={setShowPushNotificationsModal} maxWidth={450}>
      <div className='p-5 text-center'>
        <p className='pt-4'>
          You've set up in-browser notifications, but browser-level notifications are still turned off. Enable them to
          never miss an update.
        </p>
        <button disabled={isLoading} className='general-button action-button px-4 py-2' onClick={requestPermission}>
          {isLoading && <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />} Enable browser
          notifications
        </button>
        <button
          className='general-button pt-3 paragraph-p2 light-50-text text-underline-hover'
          onClick={() => {
            LocalStorage.setItem('notShowPushNotificationModalAgain', true);
            setShowPushNotificationsModal(false);
          }}
        >
          Do not show this message again
        </button>
      </div>
    </ModalComponent>
  );
};

export default PushNotificationsConfirmation;
